import { connect } from 'react-redux';
import { push } from 'react-router-redux';

import Actions from '../../actions';
import APP_ACTIONS from '../../constants/app-actions';
import CheckoutSuccessPage from '../../components/checkout-steps/checkout-success-page';
import CheckoutStepCalculator from '../../services/checkout-step-calculator';
import APP_ROUTES from '../../constants/app-routes';
import CheckoutFailPage from '../../components/checkout-steps/checkout-fail-page';

const mapStateToProps = (state, ownProps) => ({
    currentCheckoutStep: state.currentCheckoutStep,
    order: state.order,
    stores: state.stores.stores,
    placedOrder: state.placedOrder,
});

const mapDispatchToProps = (dispatch) => ({
    clearOrder: () => {
        dispatch(Actions.clearOrder());
    },
});

const CheckoutFailConnector = connect(mapStateToProps, mapDispatchToProps)(CheckoutFailPage);

export default CheckoutFailConnector;



/** WEBPACK FOOTER **
 ** ./src/containers/checkout-steps/checkout-fail-connector.js
 **/